import types from "../actions/types";

const initialState = {
  data: null,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_STOPINFO:
      return Object.assign({}, state, {
        loading: true,
      });
    case types.REQUEST_STOPINFO_FAILED:
      return initialState;
    case types.RECEIVED_STOPINFO:
      return {
        data: action.data,
        values: action.values,
        url: action.url,
        loading: false,
      };
    case types.REFRESH_STOPINFO:
      return Object.assign({}, state, {
        refreshing: true,
      });
    case types.SET_REQUEST_VALUES:
      return Object.assign({}, state, {
        values: action.values,
        url: action.url,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/stop.js